<template>
  <div data-testid="info-request">
    <div class="d-flex align-center justify-space-between mb-2 mt-1 px-2" data-testid="info-request__header">
      <h4 class="font-weight-regular" data-testid="info-request__title">Information Request</h4>
      <div data-testid="info-request__completion">
        {{ filteredCompletion }}% Completed
        <v-progress-linear :height="10" color="primary rounded-0" :value="filteredCompletion" data-testid="info-request__progress" />
      </div>
    </div>
    <v-simple-table class="mx-2 simple-table border-on radius-small mb-2 info-request__table" v-if="filteredInfoRequests.length > 0" data-testid="info-request__table">
      <template v-slot:default>
        <thead data-testid="info-request__thead" class="tableheaderbg">
          <th class="pa-2 tableHeaderBg text-left" data-testid="info-request__th-name">Name</th>
          <th class="pa-2 tableHeaderBg text-left" data-testid="info-request__th-requested-information">Requested information</th>
          <th class="pa-2 tableHeaderBg text-left" data-testid="info-request__th-type">Type</th>
          <th class="pa-2 tableHeaderBg text-left" data-testid="info-request__th-classification">Classification</th>
          <th class="pa-2 tableHeaderBg text-left" data-testid="info-request__th-requested-from">Requested from</th>
          <th class="pa-2 tableHeaderBg text-left" data-testid="info-request__th-status">Status</th>
          <th class="pa-2 tableHeaderBg text-left" data-testid="info-request__th-action">Action</th>
        </thead>
        <v-slide-y-transition group tag="tbody" style="overflow: hidden !important" data-testid="info-request__tbody">
          <tr v-for="(v, k) in filteredInfoRequests" :key="k" :data-testid="`info-request__row-${k}`">
            <td :data-testid="`info-request__cell-name-${k}`">{{v.info_owner_detail.name}}</td>
            <td class="d-flex align-center justify-space-between" @mouseover="hoverIndex = k" @mouseleave="hoverIndex = null" :data-testid="`info-request__cell-description-${k}`">
              {{ v.description }}
              <v-btn v-if="hoverIndex === k" small class="elevation-1 shadow-on white caccounting--text font-size-xm text-capitalize" @click="$nova.gotoLink({ path: `/financialclose/project/informationmanager/${taskListData.metadata._id}` })" :data-testid="`info-request__open-btn-${k}`">
                <v-icon></v-icon>
                <span>Open</span>
              </v-btn>
            </td>
            <td :data-testid="`info-request__cell-type-${k}`">{{ v.type }}</td>
            <td :data-testid="`info-request__cell-category-${k}`">{{ v.category }}</td>
            <td :data-testid="`info-request__cell-requested-from-${k}`">{{ v.info_owner_detail.email }}</td>
            <td :data-testid="`info-request__cell-status-${k}`">
              <v-chip color="lightyellow" class="yellow--text" v-if="v.stage === 0" :data-testid="`info-request__status-chip-${k}-pending-submission`">
                <span>Pending Submission</span>
              </v-chip>
              <v-chip color="lightblue" class="blue--text" v-else-if="v.stage === 1" :data-testid="`info-request__status-chip-${k}-pending-approval`">
                <span>Pending Approval</span>
              </v-chip>
              <v-chip color="lightgreen" class="green--text" v-else-if="v.stage === 2" :data-testid="`info-request__status-chip-${k}-closed`">
                <span>Closed </span>
              </v-chip>
              <v-chip color="lightred" class="error--text" v-else-if="v.stage === -1" :data-testid="`info-request__status-chip-${k}-cancelled`">
                <span>Cancelled</span>
              </v-chip>
            </td>
            <td :data-testid="`info-request__cell-actions-${k}`">
              <div class="d-flex align-center" :data-testid="`info-request__actions-wrapper-${k}`">
                <!-- Approve Action -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span>
                      <v-btn icon v-bind="attrs" v-on="on" :disabled="v.stage !== 1" @click="$emit('approve', v)" :data-testid="`info-request__approve-btn-${k}`">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <span>Approve</span>
                </v-tooltip>
                <!-- Reject Action -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span>
                      <v-btn icon v-bind="attrs" v-on="on" :disabled="v.stage !== 1" @click="$emit('reject', v)" :data-testid="`info-request__reject-btn-${k}`">
                        <v-icon color="error">mdi-close-circle-outline</v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <span>Reject</span>
                </v-tooltip>
                <!-- Download Action -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span>
                      <v-btn icon v-bind="attrs" v-on="on" :disabled="!v.fileid" @click="v.fileid && $nova.downloadFile(v.fileid)" :data-testid="`info-request__download-btn-${k}`">
                        <v-icon>mdi-download</v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <span>Download</span>
                </v-tooltip>
                <!-- Follow-up Action -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span>
                      <v-btn icon v-bind="attrs" v-on="on" @click="$emit('followup', v)" :data-testid="`info-request__followup-btn-${k}`">
                        <v-icon color="primary">mdi-calendar-clock-outline</v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <span>Follow-up</span>
                </v-tooltip>
              </div>
            </td>
          </tr>
        </v-slide-y-transition>
      </template>
    </v-simple-table>
    <div v-else class="grey--text px-4 mb-2" data-testid="info-request__empty">No Data</div>
  </div>
</template>
<script>
export default {
  name: 'InfoRequest',
  props: {
    inforeqstage: {
      type: Number,
      default: 0
    },
    metadata: {
      type: Object,
      default: () => ({})
    },
    task: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      hoverIndex: null
    }
  },
  computed: {
    filteredInfoRequests() {
      // Read pre-filtered info requests from task.__computed (server-side filtered)
      return this.task?.__computed?.infoManagerRequests || [];
    },
    filteredCompletion() {
      // Calculate percent complete for filteredInfoRequests (stage === 2 is complete)
      if (!this.filteredInfoRequests.length) return 0;
      const completed = this.filteredInfoRequests.filter(req => req.stage === 2).length;
      return Math.round((completed / this.filteredInfoRequests.length) * 100);
    },
  },
}
</script>

<style>
.info-request__table th { font-weight: 500; color: var(--color-hover-text-menu); }
</style>